import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, TranslateService, StateUtils, claimViewModel) => {
    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();

        $scope.isActive = {};
        if ($scope.claimVm.lobs.personalAuto.vehicleIncidents.value.length === 0) {
            $scope.claimVm.lobs.personalAuto.value.createVehicleIncident();
            $scope.activeIncident = $scope.claimVm.lobs.personalAuto.vehicleIncidents.getLastElement();
            $scope.activeIncident.collision.value = true;
        }
        if (!$scope.activeIncident) {
            $scope.activeIncident = $scope.claimVm.lobs.personalAuto.vehicleIncidents.getElement(0);
        }
    };

    ctrl.addVehicleIncident = function (vehiclesForm) {
        vehiclesForm.submitted = true;
        if (vehiclesForm.valid) {
            $scope.claimVm.lobs.personalAuto.value.createVehicleIncident();
            $scope.activeIncident = $scope.claimVm.lobs.personalAuto.vehicleIncidents.getLastElement();
            $scope.activeIncident.collision.value = true;
            $scope.activeIncident.active = true;
            vehiclesForm.submitted = false;
            vehiclesForm.setPristine();
        }
    };

    ctrl.removeVehicleIncident = function (vehicleIncident) {
        if ($scope.claimVm.lobs.personalAuto.vehicleIncidents.length > 1) {
            $scope.claimVm.lobs.personalAuto.value.removeVehicleIncident(vehicleIncident.value);
        }
        $scope.activeIncident = $scope.claimVm.lobs.personalAuto.vehicleIncidents.getLastElement();
    };

    ctrl.getVehicleTabHeading = function (vehicleIncident) {
        let tabHeading;
        const vehicle = vehicleIncident.vehicle.value;

        if (vehicle && vehicle.make && vehicle.model) {
            tabHeading = `${vehicle.make} ${vehicle.model}`;
        } else {
            tabHeading = TranslateService.instant('fnol.pa.controllers.PACollisionVehicleCtrl.New Vehicle');
        }

        return tabHeading;
    };

    ctrl.isTabValid = function (vehicleIncident) {
        const isValid = vehicleIncident.aspects.valid;
        return (typeof isValid !== 'undefined' && !isValid) ? 'error' : '';
    };

    ctrl.next = function (form) {
        form.submitted = true;
        flowModel.next($scope.claimVm);
    };

    ctrl.previous = function () {
        flowModel.previous($scope.claimVm);
    };
    ctrl.cancel = function () {
        flowModel.cancel($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'TranslateService', 'StateUtils', 'claimViewModel'];

export default fn;